import { combineReducers } from 'redux';

import outside from './outsideApps';
import inside from './insideApps';

export * from './outsideApps';

export default combineReducers({
  inside,
  outside,
});
